import React from 'react';
import { Body7, Container } from '@ui';

// The paragraphs under the table, rendered from the list feedTableNotes builds.
//
// Spacing is declared once here rather than six times in the table's render body — which is what
// makes "collapse these grey paragraphs into a popover" one file's change instead of six
// conditionals and two spacing idioms.
//
// Each note carries its id onto the DOM so a test can ask WHICH note appeared without matching a
// sentence. That is the anchor that survives a reword: the id says what the paragraph is for, the
// text says what it currently reads.
export const FeedTableNotes = ({ notes }) => {
  if (!notes.length) return null;

  return (
    <>
      {notes.map((note) => (
        <Container bottom={4} key={note.id}>
          <Body7 isLowContrast data-testid={`table-note-${note.id}`}>
            {note.text}
          </Body7>
        </Container>
      ))}
    </>
  );
};
